/**
 * Declension of numerals
 * @param number
 * @param titles - ['найдена', 'найдено', 'найдены']
 * @returns {String}
 */
export function declOfNums(number, titles) {
  const cases = [2, 0, 1, 1, 1, 2];

  const index = (number % 100 > 4 && number % 100 < 20)
    ? 2
    : cases[(number % 10 < 5) ? number % 10 : 5];

  return titles[index];
}

/**
 * Find closest element
 * Require Element.prototype.matches.
 * @param element
 * @param checker
 * @param last
 * @returns {*}
 */
export function findClosestElement(element, checker, last = document.body) {
  let target = element;
  let lastReached = false;

  while (target && !lastReached) {
    if (typeof checker === 'string' && target.matches(checker)) {
      return target;
    }

    if (typeof checker === 'function' && checker(target)) {
      return target;
    }

    if (target === last) {
      lastReached = true;
    }

    target = target.parentNode;
  }

  return null;
}

/**
 * Clear value of input file
 * @param el
 */
export function clearInputFile(el) {
  if (el.value) {
    try {
      el.value = '';
    } catch (err) { /* nothing */ }

    if (el.value) {
      const form = document.createElement('form');
      const ref = el.nextSibling;
      const parent = el.parentNode;

      form.appendChild(el);
      form.reset();

      if (ref) {
        ref.parentNode.insertBefore(el, ref);
      } else {
        parent.appendChild(el);
      }
    }
  }
}

export function getScrollbarWidth() {
  const inner = document.createElement('p');
  inner.style.width = '100%';
  inner.style.height = '200px';

  const outer = document.createElement('div');
  outer.style.position = 'absolute';
  outer.style.top = '0px';
  outer.style.left = '0px';
  outer.style.visibility = 'hidden';
  outer.style.width = '200px';
  outer.style.height = '150px';
  outer.style.overflow = 'hidden';
  outer.appendChild(inner);

  document.body.appendChild(outer);
  const w1 = inner.offsetWidth;
  outer.style.overflow = 'scroll';
  let w2 = inner.offsetWidth;
  if (w1 === w2) w2 = outer.clientWidth;

  document.body.removeChild(outer);

  return w1 - w2;
}

export function getZIndex(el) {
  if (!el || el.nodeType !== Node.ELEMENT_NODE) return 0;
  const index = +window.getComputedStyle(el).zIndex;
  if (Number.isNaN(index)) return getZIndex(el.parentNode);
  return index;
}

export function toggleClass(el, className, condition) {
  if (typeof condition === 'undefined') {
    condition = !el.classList.contains(className);
  }

  if (condition) {
    el.classList.add(className);
  } else {
    el.classList.remove(className);
  }
}

export function getPrecision(num) {
  if (!Number.isFinite(num)) {
    return 0;
  }

  let e = 1;
  let p = 0;

  while (Math.round(num * e) / e !== num) {
    e *= 10;
    p++;
  }
  return p;
}

export function splitDigits(value, thousandsSeparator = ',', decimalsSeparator = '.') {
  if (!value) return '';

  return value.toString()
    .replace('.', decimalsSeparator)
    .replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);
}
